import styled from '@emotion/styled';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2b2b2b1a;
  z-index: 1200;
`;

export const ChildrenStyled = styled.div`
  box-shadow: 10px 10px 20px rgba(9, 30, 63, 0.2);
`;
